/**
 * Фиче-флаги фронтенда. Единая точка правды для условного показа функциональности,
 * которую по продуктовым причинам временно прячем, но НЕ удаляем логику.
 */

/**
 * Показывать всё, что завязано на десктоп-приложение (Tauri):
 * - режим продвижения по сетке «Через десктоп-приложение» (авто-результаты);
 * - режим сбора статистики «Десктоп»;
 * - баннер/ссылку «Скачать приложение» и плашку покрытия статистики;
 * - десктоп-ветку правил;
 * - ноту «для 1×1 требуется десктоп».
 *
 * Пока десктоп-приложение не готово к массовой раздаче — false. Логику под флагом
 * НЕ удалять: включение вернёт функциональность без переписывания.
 */
export const SHOW_TAURI_FEATURES = false;
